import React, { Suspense, useEffect } from "react";
import { notification } from "antd";
import ProfileModalVerifySkill from "./ProfileModalVerifySkill";
import Spinner from "@/components/Spinner";

// Utils
import { useMyActivityV3 } from "@/hooks/useMyActivityV3";
import ListActivityContainer from "./ListActivityContainer";

// Add interface for props
interface ProfileSectionActivityInfiniteProps {}

const ProfileSectionActivityInfinite: React.FC<
  ProfileSectionActivityInfiniteProps
> = ({}) => {
  // State

  const { fetchMyActivities } = useMyActivityV3({});

  useEffect(() => {
    fetchMyActivities();
    const interval = setInterval(() => {
      fetchMyActivities();
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>

      {/* {isLoadingFetchMyActivityInitial ? (
        <div className="flex justify-center items-center">
          <Spinner />
        </div>
      ) : ( */}
      <ListActivityContainer />
      {/* )} */}

      <Suspense
        fallback={
          <div className="flex justify-center">
            <Spinner />
          </div>
        }
      >
        <ProfileModalVerifySkill refetch={fetchMyActivities} />
      </Suspense>
    </>
  );
};
export default ProfileSectionActivityInfinite;
